/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Time-limited signed URL for preview (7 days)
 * @export
 * @interface SignedUrl
 */
export interface SignedUrl {
}

/**
 * Check if a given object implements the SignedUrl interface.
 */
export function instanceOfSignedUrl(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SignedUrlFromJSON(json: any): SignedUrl {
    return SignedUrlFromJSONTyped(json, false);
}

export function SignedUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignedUrl {
    return json;
}

export function SignedUrlToJSON(value?: SignedUrl | null): any {
    return value;
}

